import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/_service/api.service';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { environment } from 'src/environments/environment';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-orders',
	templateUrl: './orders.component.html',
})
export class OrdersComponent implements OnInit {
	constructor(
		private api: ApiService,
		private modalService: NgbModal,
		private auth: AuthService,
		private router: Router,
		private translate: TranslateService,
	) {}

	ordini = [];
	ordiniVisualizzati = [];
	ordineSelected: any;

	anni = [];

	filtri = {
		anno: new Date().getFullYear(),
		daConfermare: false,
		parola: '',
	};

	jsonInMail: any = {};
	mailError = '';
	idOrdineMail;

	utente = this.auth.getUser();

	indirizzi = [];
	showContainerizzazione = false;

	ngOnInit() {
		this.showContainerizzazione = this.auth.getUser().containerizzazioneOrdini;
		for (let i = new Date().getFullYear(); i >= 2021; i--) {
			this.anni.push(i);
		}
		this.aggiornaOrdini();
		this.indirizzi = this.auth.getUser().cliente.indirizziSpedizione.filter((i) => !i.cancellato);
	}

	aggiornaOrdini() {
		this.api.getOrdiniFiltrati(this.filtri.anno, undefined).subscribe((res) => {
			this.ordini = res.sort((a, b) => b.dataRegistrazioneOrdine - a.dataRegistrazioneOrdine).filter((o) => o.prodottiCarrello.length > 0);
			this.ordiniVisualizzati = this.ordini;
			console.log(
				'ORDINE',
				this.ordini.find((ordine) => ordine.id === 294),
			);
			this.ordini.forEach((o) => {
				o.prodottiCarrello.forEach((pc) => {
					pc.prodottoCommerciale.listini = pc.prodottoCommerciale.listini.filter(
						(l) => l.cliente === this.auth.getUser().cliente.codiceCliente,
					);
				});
				o.jsonIn = {
					dataConsegnaRichiesta: moment(o.dataConsegnaRichiesta).format('yyyy-MM-DD'),
					rifOrdineCliente: o.rifOrdineCliente,
					idOrdine: o.id,
					codiceIndirizzoSpedizioneAS400: o.indirizzo?.codiceCliente,
				};
			});
			this.filtra();
		});
	}

	getDescrizione(prodotto) {
		return prodotto.descrizioni.find((d) => d.lingua.codice === 'US');
	}

	modificaOrdine(ordine) {
		this.api.modifyOrder(ordine.jsonIn).subscribe((res) => {
			ordine.isEdit = false;
			ordine.dataConsegnaRichiesta = res.dataConsegnaRichiesta;
			ordine.indirizzo = res.indirizzo;
			ordine.rifOrdineCliente = res.rifOrdineCliente;
		});
	}

	filtra() {
		this.filtri.parola = this.filtri.parola.trim().toUpperCase();
		this.ordiniVisualizzati = this.ordini.filter((o) => {
			return (
				o.id.toString().toUpperCase().includes(this.filtri.parola) ||
				`${o.indirizzo?.indirizzo}, ${o.indirizzo?.localita} ${o.indirizzo?.provincia} ${o.indirizzo?.cap}`
					.toUpperCase()
					.includes(this.filtri.parola) ||
				o.prodottiCarrello.find((pc) => pc.prodottoCommerciale.codiceCommerciale.toUpperCase().includes(this.filtri.parola)) ||
				(o.rifOrdineCliente != null ? o.rifOrdineCliente.toUpperCase().includes(this.filtri.parola) : console.log()) ||
				o.prodottiCarrello.find((pc) =>
					pc.nOrdineSimag != null ? pc.nOrdineSimag.toUpperCase().includes(this.filtri.parola) : console.log(),
				) ||
				// (o.prodottiCarrello.find(pc => { if (pc.nOrdineSimag != null) { pc.nOrdineSimag.toUpperCase().includes(this.filtri.parola) } })) ||
				o.prodottiCarrello.find((pc) => {
					if (pc.totale != null) {
						pc.totale.toString().toUpperCase().includes(this.filtri.parola);
					}
				}) ||
				o.prodottiCarrello.find((pc) => {
					if (pc.quantita != null) {
						pc.quantita.toString().toUpperCase().includes(this.filtri.parola);
					}
				})
			);
		});
	}

	openMail(contentMail, idOrdineMail) {
		this.idOrdineMail = idOrdineMail;
		const user = this.auth.getUser();
		this.jsonInMail.sender = environment.mailFrom;
		this.jsonInMail.recipients = user.email;
		this.modalService.open(contentMail, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
	}

	sendMail(contentMail, mailSuccess) {
		this.mailError = '';
		this.jsonInMail.codice_lingua = this.translate.currentLang;
		this.jsonInMail.idOrdine = this.idOrdineMail;
		this.api.sendMailOrdine(this.jsonInMail).subscribe((res: any) => {
			if (res.esito === 'OK') {
				this.jsonInMail = {};
				contentMail.close();
				this.modalService.open(mailSuccess, { ariaLabelledBy: 'modal-basic-title' }).result.then(() => {});
			} else {
				this.mailError = res.descrizione;
			}
		});
	}

	getPdfOrdine(idOrdine) {
		this.api.getPdfOrdine({ codice_lingua: this.translate.currentLang, idOrdine }).subscribe((blob) => {
			console.log(blob);
			if (blob.size === 0) {
				alert('There was a problem while generating the pdf file.');
			}
			const URL = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			document.body.appendChild(a);
			a.setAttribute('style', 'display: none');
			a.href = URL;
			a.download = 'Bertazzoni Order n.' + idOrdine + '.pdf';
			a.click();
			window.URL.revokeObjectURL(URL);
			a.remove();
		});
	}

	getExcelOrdine(idOrdine) {
		this.api.getExcelOrdine({ codice_lingua: this.translate.currentLang, idOrdine }).subscribe((blob) => {
			console.log(blob);
			if (blob.size === 0) {
				alert('There was a problem while generating the xlsx file.');
			}
			const URL = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			document.body.appendChild(a);
			a.setAttribute('style', 'display: none');
			a.href = URL;
			a.download = 'Bertazzoni Order n.' + idOrdine + '.xlsx';
			a.click();
			window.URL.revokeObjectURL(URL);
			a.remove();
		});
	}

	getPrezzo(item, ordine) {
		if (ordine.company.connettore === 'SAGEX3') {
			return item.prezzoUnitarioOriginale;
		}
		const listino = item.prodottoCommerciale.listini[0];
		return listino ? listino.prezzoNetto : 0;
	}

	totaleOrdine(ordine) {
		let totale = 0;
		ordine.prodottiCarrello.forEach((item) => {
			totale += this.getPrezzo(item, ordine) * item.quantita;
		});
		return totale;
	}

	trovaNSimag(ordine) {
		const item = ordine.prodottiCarrello.find(({ nOrdineSimag }) => nOrdineSimag && nOrdineSimag !== '0' && nOrdineSimag.trim() !== '');
		return item ? item.nOrdineSimag : 'N/D';
	}

	toContainer(ordine) {
		this.api.getSpedizioneByOrder({ idOrdine: ordine.id }).subscribe((spedizione) => {
			if (!spedizione) {
				this.api
					.saveSpedizione({
						idOrdine: ordine.id,
						tipoSpedizione: 'ORDINE',
					})
					.subscribe((newSpedizione) => this.router.navigate(['/edit-container', newSpedizione.id]));
			} else {
				this.router.navigate(['/edit-container', spedizione.id]);
			}
		});
	}

	apriModalePriorita(ordine, content) {
		this.ordineSelected = ordine;
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
	}

	savePriorita(modal) {
		const body = {
			idOrdine: this.ordineSelected.id,
			prioritario: this.ordineSelected.prioritario,
			listIdProdottoCarrello: this.ordineSelected.prodottiCarrello.filter((pc) => pc.prioritario).map((pc) => pc.id),
		};
		this.api.setPrioritaOrdine(body).subscribe((res: any) => {
			if (res.esito === 'OK') {
				this.ordini.splice(this.ordini.indexOf(this.ordini.find((o) => o.id === this.ordineSelected.id)), 1, res.result);
				this.ordiniVisualizzati.splice(this.ordiniVisualizzati.indexOf(this.ordineSelected), 1, res.result);
				modal.close();
			} else {
				alert('Errore: ' + res.descrizione);
			}
		});
	}

	getMessaggioPrioritario(ordine) {
		if (ordine.prioritario) {
			return 'The whole order is prioritized';
		} else if (ordine.prodottiCarrello.find((pc) => pc.prioritario)) {
			return 'Some items are prioritized';
		} else {
			return '';
		}
	}
}
